const CheckboxUnChecked = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <path
      fill="var(--checkbox-unchecked-fill)"
      stroke="var(--checkbox-unchecked-stroke)"
      strokeWidth={2}
      d="M.5 4A3.5 3.5 0 0 1 4 .5h16A3.5 3.5 0 0 1 23.5 4v16a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 20V4Z"
    />
  </svg>
)
export { CheckboxUnChecked }
